import styled from 'styled-components';

const sizes = {
  normal: '210px',
  small: '120px',
  large: '290px',
};

const getSize = (p) => {
  if (p.small) {
    return sizes.small;
  }
  if (p.large) {
    return sizes.large;
  }
  return sizes.normal;
};

export const NoteTitle = styled.div`
  flex: 1;

  > label {
    font-weight: ${p => p.theme.fontWeight.bold};
    text-transform: uppercase;
    font-size: 10px;
  }
`;

export const NoteName = styled.div`
  color: ${p => p.theme.colors.darkTheme};
  font-size: 20px;
  font-weight: ${p => p.theme.fontWeight.bold};
`;

export const NoteText = styled.div`
  font-size: 16px;
  height: ${p => getSize(p)};
  white-space: pre-wrap;
  font-weight: ${p => p.theme.fontWeight.bold};
  overflow-y: auto;
`;
